import { useIntl } from 'react-intl';
import type { LandIqDataRunDetail } from '@immo/api-contract';

type Props = {
  readonly chunks: NonNullable<NonNullable<LandIqDataRunDetail['progress']>['chunks']>;
  readonly queueDepth: number;
};

export function RunChunks({ chunks, queueDepth }: Props) {
  const intl = useIntl();
  const number = (value: number, danger = false) => (
    <b className={danger ? 'text-danger-700' : undefined}>{intl.formatNumber(value)}</b>
  );

  return (
    <div className="rounded-md border border-border bg-surface px-4 py-3 text-sm">
      <div className="text-text-primary">
        {intl.formatMessage(
          { id: 'pages.admin.landiq-data-run.chunks' },
          {
            incoming: number(chunks.incoming),
            processed: number(chunks.processed),
            failed: number(chunks.failed, chunks.failed > 0),
          },
        )}
      </div>
      <div className="mt-1 text-text-secondary">
        {intl.formatMessage({ id: 'pages.admin.landiq-data-run.queue' }, { queueDepth: intl.formatNumber(queueDepth) })}
      </div>
    </div>
  );
}
